import { useRootStore } from "~/store/root"

export default defineNuxtPlugin((nuxtApp) => {
  const isEmbeddedRoute = useRoute().path.includes('/embedded')
  const { isEmbedded } = useRootStore()

  function validateEmbeddedLoaded() {
    if ((isEmbedded || isEmbeddedRoute) && window) {
      window.parent.postMessage({
        source: 'BP',
        method: 'iframeStylesReady',
        action: 'iframeStylesReady'
      }, "*")
    }
  }

  nuxtApp.hook('page:finish', () => {
    validateEmbeddedLoaded()
  })

  nuxtApp.hook('app:error', () => {
    validateEmbeddedLoaded()
  })
})
